import { StyleSheet, Dimensions } from "react-native";

const { width, height } = Dimensions.get('window');
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
const isSmallDesktop = width >= 1024 && width <= 1440;
const isLargeDesktop = width > 1440;
const fontFamilies = { Bodoni72Smallcaps: "Bodoni72Smallcaps" };

const styles = StyleSheet.create({
	body: {
		flex: 1,
		overflow: "hidden",
		maxHeight: "100vh",
		touchAction: "none", // Disable scrolling
	},
	section: {
		flex: 1, // Each section takes up an equal portion of the screen's height
		minHeight: "100vh",
		zIndex: 1,
		overflow: "hidden", // Ensure that this is not scrollable beyond the view height
	},
	headerBar: {
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		width: '100%',
		zIndex: 2000,
		paddingHorizontal: isMobile ? 20 : isTablet ? 30 : isSmallDesktop ? 40 : 60,
		paddingTop: isMobile ? 30 : isTablet ? 40 : 50,
		paddingBottom: isMobile ? 8 : 12,
		boxSizing: 'border-box',
	},
	headerRightGroup: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 12,
	},
	logoArea: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		maxHeight: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
	},
	loginArea: {
		marginRight: isMobile ? 225 : isTablet ? 250 : isSmallDesktop ? 50 : 0,
		flex: 0.5,
		flexDirection: "row",
		backgroundColor: "transparent",
		maxHeight: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
	},
	registerButton: {
		width: isMobile ? 125 : isTablet ? 180 : isSmallDesktop ? 200 : 300,
		height: isMobile ? 40 : isTablet ? 40 : isSmallDesktop ? 40 : 60,
		backgroundColor: "#4c956c",
		shadowOffset: { width: 7, height: 3 },
		shadowRadius: 6,
		shadowColor: "rgba(0, 0, 0, 0.04)",
		alignItems: "center",
		justifyContent: "center",
		marginRight: isMobile ? 10 : 0,
		padding: isMobile ? 10 : 0,
		transition: "transform 0.4s ease-in-out", // Add transition for smooth effect
		minWidth: isTablet ? 180 : undefined, // Prevent wrapping on tablet
		whiteSpace: isTablet ? 'nowrap' : undefined, // Prevent wrapping on tablet
		alignSelf: "center",
	},
	registerButtonHover: {
		transform: [{ scale: 1.025 }], // Scale up on hover
	},
	registerButtonText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "bold",
		fontSize:  isMobile ? 16 : isTablet ? 16 : isSmallDesktop ? 18 : 25,
		lineHeight: isMobile ? 20 : isTablet ? 25 : isSmallDesktop ? 30 : 35,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	loginButton: {
		width: isMobile ? 125 : isTablet ? 125 : isSmallDesktop ? 150 : 300,
		height: isMobile ? 40 : isTablet ? 40 : isSmallDesktop ? 40 : 60,
		backgroundColor:  isMobile ? "#4c956c" : "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		transition: "transform 0.4s ease-in-out",
		alignSelf: "center",
	},
	loginButtonHover: {
		transform: [{ scale: 1.025 }], 
	},
	loginButtonText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "bold",
		fontSize:  isMobile ? 16 : isTablet ? 16 : isSmallDesktop ? 18 : 25,
		lineHeight: 30,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor:  "rgba(0, 0, 0, 0.09)",
	},

	logoText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontWeight: "normal",
		fontSize: isMobile ? 0 : isTablet ? 40 : isSmallDesktop ? 50 : 50,
		textAlign: "left",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		alignSelf: "center",
		lineHeight: isMobile ? 0 : isTablet ? 40 : isSmallDesktop ? 50 : 50,
	},
	contentArea: {
		flex: 1,
		flexDirection: "column",
		justifyContent: "center",
		backgroundColor: "transparent",
		marginTop: isMobile ? 80 : isTablet ? 90 : isSmallDesktop ? 100 : 110, // add margin to prevent overlap with header
		padding: isMobile ? 20 : isTablet ? 30 : isSmallDesktop ? 50 : 70,
	},
	content: {
		flex: 1,
		flexDirection: "column",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		padding: isMobile ? 0 : isTablet ? 30 : isSmallDesktop ? 50 : 70,
	},
	footer: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		padding: isMobile ? 0 : isTablet ? 30 : isSmallDesktop ? 50 : 70,
	},
	footerText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "bold",
		fontSize:  isMobile ? 8 : isTablet ? 16 : isSmallDesktop ? 25 : 25,
		lineHeight: isMobile ? 20 : isTablet ? 25 : isSmallDesktop ? 30 : 35,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	footerButton: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton2: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton3: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton4: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton5: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton6: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton7: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		cursor: 'pointer',
	},
	footerButton8: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton9: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton10: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton11: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton12: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton13: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton14: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton15: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton16: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton17: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton18: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton19: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton20: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton21: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
	},
	footerButton22: {
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 30 : isTablet ? 40 : isSmallDesktop ? 50 : 60,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		maxHeight: 500,
		marginHorizontal: isMobile ? 20 : isTablet ? 50 : isSmallDesktop ? 90 : 140,
		zIndex: 3,
	},

	headerText: {
		width: isMobile ? 350 : isTablet ? 900 : isSmallDesktop ? 1000 : 1000,
		height: isMobile ? 40 : isTablet ? 150 : isSmallDesktop ? 130 : 200,
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontWeight: "normal",
		fontSize: isMobile ? 40 : isTablet ? 70 : isSmallDesktop ? 60 : 100,
		textAlign: "left",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 5,
		textShadowColor: "rgba(0, 0, 0, 0.06)",
		zIndex: 99,
		marginBottom: isMobile ? 40 : 0
	},

	descriptionText: {
		width: isMobile ? 300 : isTablet ? 700 : isSmallDesktop ? 900 : 900,
		height: isMobile ? 40 : isTablet ? 100 : isSmallDesktop ? 80 : 250,
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: isMobile ? 20 : isTablet ? 40 : isSmallDesktop ? 30 : 50,
		lineHeight: isMobile ? 24 : isTablet ? 40 : isSmallDesktop ? 30 : 50,
		textAlign: "left",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.16)",
		marginVertical: isMobile ? 40 : isTablet ? 40 : isSmallDesktop ? 20 : 50,
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		zIndex: 99,
		paddingBottom: isMobile ? 80 : 0
	},

		button: {
		width: isMobile ? 200 : isTablet ? 300 : isSmallDesktop ? 550 : 550,
		height: isMobile ? 30 : isTablet ? 50 : isSmallDesktop ? 60 : 65,
		backgroundColor: "#4c956c",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 50,
		marginTop: isMobile ? -50 : isTablet ? 15 : isSmallDesktop ? -75 : -50,
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		zIndex: 99,
	},
	getStartedButton: {
		width: isMobile ? 200 : isTablet ? 300 : isSmallDesktop ? 400 : 550,
		height: isMobile ? 44 : isTablet ? 50 : isSmallDesktop ? 50 : 65,
		backgroundColor: "#4c956c",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: isMobile ? 10 : 50,
		marginTop: isMobile ? 80 : isTablet ? 15 : isSmallDesktop ? -30 : -150,
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		zIndex: 9999,
		transition: "transform 0.4s ease-in-out", // Add transition for smooth effect
		padding: isMobile ? 10 : 0, // Add padding for mobile for better touch area
	},
	getStartedButtonHover: {
		transform: [{ scale: 1.025 }], // Scale up on hover
	},
	
	buttonText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: isMobile ? 18 : isTablet ? 26 : isSmallDesktop ? 26 : 32,
		lineHeight: 30,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		zIndex: 99,
	},

	backgroundImage: {
		flex: 1,
		resizeMode: "cover",
	},
	blurred: {
		position: "absolute",
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		backdropFilter: "blur(10px)", // Apply blur effect
	},
	blurredContainer: {
		// Apply a blur effect
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fallback for mobile that doesn't support backdropFilter
		backdropFilter: "blur(10px)",
		zIndex: 1000, // Ensure it's above other content
	},
	popupContainer: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		position: "absolute",
		zIndex: 1010, // Higher than blurredContainer
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		borderRadius: isMobile ? 0 : 50
	},
	popup: {
		borderRadius: isMobile ? 20 : 50,
		zIndex: 1020
	},
	overlayBlur: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fallback for mobile
		backdropFilter: "blur(10px)", 
		zIndex: 100
	},
	uploadButton: {
		padding: 10,
		backgroundColor: "#FEFCE0",
		borderRadius: 5,
		marginTop: isMobile ? 10 : isTablet ? 20 : isSmallDesktop ? 30 : 40, // Adjust as needed
	},
	ribbonContainer: {
		position: 'absolute',
		bottom: isMobile ? 20 : isTablet ? 20 : isSmallDesktop ? 30 : 40,
		right: isMobile ? 20 : isTablet ? 20 : isSmallDesktop ? 30 : 40,
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 9999,
		backgroundColor: "#4c956c",
		padding: 10,
		borderRadius: isMobile ? 30 : 10,
		width: isMobile ? 40 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		height: isMobile ? 40 : 'auto',
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon1: {
		position: 'absolute',
		bottom: '-100%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 1001,
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250,
		alignItems: "center",
		// Add shadow
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon2: {
		position: 'absolute',
		bottom: isMobile ? '-200%' : isTablet ? '-250%' : isSmallDesktop ? '-300%' : '-350%', // Initially hidden
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c', // Yellow color for the ribbon
		padding: 10,
		borderRadius: 10,
		zIndex: 100, // Ensure it's above other elements
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250, // Adjusted for smaller screens
		alignItems: "center",
	},
	ribbon3: {
		position: 'absolute',
		bottom: isMobile ? '-300%' : isTablet ? '-350%' : isSmallDesktop ? '-400%' : '-450%', // Initially hidden
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c', // Yellow color for the ribbon
		padding: 10,
		borderRadius: 10,
		zIndex: 100, // Ensure it's above other elements
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250, // Adjusted for smaller screens
		alignItems: "center",
	},
	ribbon4: {
		position: 'absolute',
		bottom: isMobile ? '-400%' : isTablet ? '-450%' : isSmallDesktop ? '-500%' : '-550%', // Initially hidden
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c', // Yellow color for the ribbon
		padding: 10,
		borderRadius: 10,
		zIndex: 100, // Ensure it's above other elements
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250, // Adjusted for smaller screens
		alignItems: "center",
	},
	ribbon5: {
		position: 'absolute',
		bottom: isMobile ? '-500%' : isTablet ? '-550%' : isSmallDesktop ? '-600%' : '-650%', // Initially hidden
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c', // Yellow color for the ribbon
		padding: 10,
		borderRadius: 10,
		zIndex: 100, // Ensure it's above other elements
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250, // Adjusted for smaller screens
		alignItems: "center",
	},
	ribbon6: {
		position: 'absolute',
		bottom: isMobile ? '-600%' : isTablet ? '-650%' : isSmallDesktop ? '-700%' : '-750%', // Initially hidden
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c', // Yellow color for the ribbon
		padding: 10,
		borderRadius: 10,
		zIndex: 100, // Ensure it's above other elements
		width: isMobile ? 100 : isTablet ? 150 : isSmallDesktop ? 200 : 250, // Adjusted for smaller screens
		alignItems: "center",
	},
	ribbonText: {
		color: '#FFFFFF', // White text
		fontWeight: 'bold',
		textAlign: 'center'
	},
	privateMessageContainer: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		position: "absolute",
		zIndex: 3,
		top: 0, // These changes ensure the popup
		bottom: 0, // covers the whole screen
		left: 0, // and is centered.
		right: 0,
		backgroundColor: "#4c956c",
	},
	resourcesOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(76, 149, 108, 0.95)',
		zIndex: 10000,
		justifyContent: 'center',
		alignItems: 'center',
	},
	resourcesOverlayCloseButton: {
		position: 'absolute',
		top: 20,
		right: 20,
		width: 40,
		height: 40,
		borderRadius: 20,
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 10001,
	},
	resourcesOverlayCloseButtonText: {
		fontSize: 18,
		fontWeight: 'bold',
		color: '#FEFCE0',
	},
	resourcesOverlayContent: {
		width: '80%',
		maxHeight: '80%',
		borderRadius: 10,
		paddingBottom: 100,
		alignItems: 'center',
	},
	resourcesOverlayTitle: {
		fontSize: 24,
		fontWeight: 'bold',
		color: '#FEFCE0',
		marginBottom: 20,
		fontFamily: "Bodoni72Smallcaps",
	},
	resourcesOverlayItem: {
		width: '100%',
		padding: 15,
		borderRadius: 10,
		marginBottom: 10,
		alignItems: 'center',
	},
	resourcesOverlayItemText: {
		fontSize: 18,
		color: '#FEFCE0',
		textAlign: 'center',
		fontWeight: 'bold',
		fontFamily: "Bodoni72Smallcaps",
	},
	socialMediaContainer: {
		position: 'fixed',
		bottom: 20,
		left: 20,
		zIndex: 1000,
		flexDirection: 'row',
		alignItems: 'center',
		gap: 15,
	},
	socialMediaText: {
		color: '#fefde2',
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 16 : 18,
		fontWeight: '500',
		textShadowOffset: { width: 2, height: 2 },
		textShadowRadius: 4,
		textShadowColor: "rgba(0, 0, 0, 0.2)",
	},
	socialMediaLinks: {
		flexDirection: 'row',
		gap: 12,
	},
	socialLink: {
		backgroundColor: 'rgba(76, 149, 108, 0.8)',
		width: isMobile ? 36 : 40,
		height: isMobile ? 36 : 40,
		borderRadius: 20,
		justifyContent: 'center',
		alignItems: 'center',
		transition: 'all 0.2s ease',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#2c6e49',
			transform: [{ scale: 1.1 }],
		},
	},
	socialIcon: {
		filter: 'drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.2))',
	},
	socialLinkText: {
		color: '#fefde2',
		fontSize: isMobile ? 14 : 16,
		fontFamily: "Orpheus Pro",
		fontWeight: '500',
		textShadowOffset: { width: 1, height: 1 },
		textShadowRadius: 2,
		textShadowColor: "rgba(0, 0, 0, 0.2)",
	},
	// Desktop Resources Modal (matching Hub.js styles)
	desktopResourcesButton: {
		position: 'fixed',
		bottom: isMobile ? '23%' : isSmallDesktop ? 150 : 170,
		right: isMobile ? 20 : isTablet ? 40 : isSmallDesktop ? 40 : 40,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: "#4c956c",
		padding: 10,
		borderRadius: isMobile ? 30 : 10,
		zIndex: 9999,
		width: isMobile ? 40 : 175,
		height: isMobile ? 40 : 'auto',
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	desktopResourcesButtonText: {
		color: '#FFFFFF',
		fontWeight: 'bold',
		textAlign: 'center',
		width: 100,
	},
	desktopResourcesOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		zIndex: 9998,
		backdropFilter: "blur(5px)",
	},
	desktopResourcesPanel: {
		position: 'fixed',
		top: 0,
		right: 0,
		width: 300,
		height: '100%',
		backgroundColor: 'rgba(76, 149, 108, 0.95)',
		zIndex: 9999,
		boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.3)',
		padding: 20,
		display: 'flex',
		flexDirection: 'column',
	},
	desktopResourcesCloseButton: {
		position: 'absolute',
		top: 20,
		right: 20,
		width: 40,
		height: 40,
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 10000,
	},
	desktopResourcesCloseButtonText: {
		fontSize: 24,
		fontWeight: 'bold',
		color: '#FEFCE0',
	},
	desktopResourcesTitle: {
		fontSize: 30,
		fontWeight: 'bold',
		color: '#FEFCE0',
		marginTop: 40,
		marginBottom: 30,
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		textAlign: 'center',
	},
	desktopResourcesContent: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginBottom: 40,
		overflowY: 'auto',
	},
	desktopResourcesItem: {
		width: '100%',
		padding: 15,
		marginBottom: 10,
		borderRadius: 10,
		alignItems: 'center',
		transition: 'transform 0.2s ease',
	},
	desktopResourcesItemHover: {
		transform: [{ scale: 1.05 }],
		backgroundColor: 'rgba(255, 255, 255, 0.1)',
	},
	desktopResourcesItemText: {
		fontSize: 20,
		color: '#FEFCE0',
		textAlign: 'center',
		fontWeight: 'bold',
		fontFamily: fontFamilies.Bodoni72Smallcaps,
	},
	headerContentRow: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		...(isTablet ? { maxWidth: 900, marginHorizontal: 'auto' } : {}),
	},
});

export default styles;